<template>
  <div>
    <v-app-bar
        outlined
        flat
        color="white"
        height="52px"
        style="border-bottom: 1px solid #EDEDED !important;"
    >
      <v-icon style="font-size:30px;" @click="backToList()">mdi-arrow-left</v-icon>
      <v-toolbar-title>Benutzerdefinierte Umfrage</v-toolbar-title>
      <div>
      </div>
    </v-app-bar>
    <div class="border-bottom stepper pa-2">
      <v-col class="ma-0 pa-0 d-flex flex-row ml-10">
        <div class="mr-5 mh-100" v-for="step in steps" :key="step.idx">
          <span :class="currentStep === step.idx ? 'focus' : 'no-focus'"
                class="mr-8"
                @click="selectedQuestions.length != 0 && surveyDetails.title != '' ? currentStep =
                step.idx : null"
                :role="selectedQuestions.length != 0 && surveyDetails.title != '' ? 'button' : null"
          >
            <span small :class="currentStep === step.idx ? 'stepper-numbering__focus' : 'stepper-numbering__no-focus'"
                  class="stepper-numbering">{{
              step.idx }}</span>
            {{ step.text }}
          </span>
        </div>
      </v-col>
    </div>
    <ConfirmDialog ref="backToListDlg" />
    <v-row v-if="currentStep === 1" class="px-12 ma-0 stepper-main">
      <v-col>
        <div class="ml-2 mt-4">
          <h2>Fragen für die Umfrage auswählen</h2>
          <p class="text-description text-gray mb-5">Nachdem Sie Fragen wählen, ziehen Sie die Fragen nach rechts, um eine Seite zu erstellen. Die gewählten Fragen werden in einer Seite zusammengepackt.</p>
        </div>
        <v-row class="question-main">
          <v-col cols="5">
            <v-row>
                <div>
                  <h3><v-icon small>mdi-format-list-bulleted</v-icon>Verfügbare Fragen</h3>
                </div>
                <div>
                  <div
                      class="infobox-container__icon"
                      @mouseover="showInfobox()"
                      @mouseleave="hideInfobox()">
                    <v-icon color="primary">mdi-information-outline</v-icon>
                  </div>
                  <InfoboxTooltip style="left: 40px;" ref="infoBox"/>
                </div>
                <v-spacer />
                <v-btn color="primary" medium elevation="0" @click="createQuestion">
                  <v-icon color="#F5F5F5" medium>add</v-icon > Neue Frage
                </v-btn>
            </v-row>
            <drag class="column" :data="selected">
              <v-data-table
                  :headers="headers"
                  :items="pxQuestions"
                  :items-per-page="-1"
                  item-text="text"
                  item-key="id"
                  :search="search"
                  hide-default-footer
                  show-select
                  v-model="selected"
                  :single-expand="singleExpand"
                  show-expand
                  @current-items="currentItems"
              >
                <template v-slot:top>
                  <div class="d-flex">
                    <v-chip small label
                            color="primary_light"
                            text-color="primary"
                            class="px-2 ml-1 mt-5"
                    >{{ filteredQuestions.length
                      }} Fragen</v-chip>
                    <v-text-field
                        v-model="search"
                        label="Fragen durchsuchen"
                        class="mx-4"
                        clearable
                        append-icon="search"
                        color="secondary"
                    ></v-text-field>
                  </div>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <PXSurvey :schema="getQuestionSchema(item)" :displayMode="'display'"
                              id="px-survey-preview"/>
                  </td>
                </template>
                <template v-slot:item.actions="{ item }">
                  <drag :data="getItem(item)">
                    <v-icon>mdi-drag-horizontal-variant</v-icon>
                    <template v-slot:drag-image>
                      <v-badge color="red" style="transform: translate(10px, 5px)">
                        <template v-slot:badge>{{selected.length > 0 ? selected.length:'1'}}</template>
                        <v-icon large color="primary">mdi-format-list-bulleted</v-icon>
                      </v-badge>
                    </template>
                  </drag>
                </template>
              </v-data-table>
              <template v-slot:drag-image>
                <v-badge color="red" style="transform: translate(10px, 5px)">
                  <template v-slot:badge>{{selected.length}}</template>
                  <v-icon large color="primary">mdi-format-list-bulleted</v-icon>
                </v-badge>
              </template>
            </drag>
          </v-col>
          <v-divider
              vertical
          ></v-divider>
          <v-col cols="7" class="px-pages-preview bg-white pa-4 pl-8">
            <h3 class="d-inline-flex align-center mb-4"><v-icon small class="mr-2">mdi-note-multiple-outline</v-icon>
              Seiten der
              Umfrage</h3>
            <div v-if="isEmpty()"
                 class="empty-image">
              <drop @drop="onDrop" class="full-width d-flex flex-column align-center justify-center">
                <div style="padding-top: 14%;">
                  <svg width="232" height="173" viewBox="0 0 232 173" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="200.5" cy="141" rx="31.5" ry="32" fill="#EBEBEB"/>
                    <g clip-path="url(#clip0_3327_18240)">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M184.425 121H158.758V119.417H184.425V121Z" fill="#929CA9"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M184.425 113.083H158.758V111.5H184.425V113.083Z" fill="#929CA9"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M184.425 128.916H158.758V127.333H184.425V128.916Z" fill="#929CA9"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M160.987 90.1041C160.987 86.1949 164.126 83.0107 168.007 83.0107C171.887 83.0107 175.027 86.1835 175.027 90.1041C175.027 91.178 174.785 92.1872 174.36 93.0913H176.751C179.942 93.0913 182.528 95.7046 182.528 98.9285V104.766H153.496V98.9285C153.496 95.7046 156.083 93.0913 159.273 93.0913H161.659C161.234 92.1892 160.987 91.1804 160.987 90.1041ZM168.007 84.5941C164.993 84.5941 162.554 87.0677 162.554 90.1041C162.554 91.3403 162.979 92.4747 163.671 93.408L164.612 94.6746H159.273C156.948 94.6746 155.063 96.5791 155.063 98.9285V103.182H180.961V98.9285C180.961 96.5791 179.076 94.6746 176.751 94.6746H171.39L172.345 93.4039C173.043 92.4761 173.46 91.3439 173.46 90.1041C173.46 87.058 171.022 84.5941 168.007 84.5941Z" fill="#929CA9"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M141 102.707C141 99.4834 143.586 96.8701 146.777 96.8701H151.771V98.4535H146.777C144.452 98.4535 142.567 100.358 142.567 102.707V153.163C142.567 155.512 144.452 157.417 146.777 157.417H189.223C191.548 157.417 193.433 155.512 193.433 153.163V102.707C193.433 100.358 191.548 98.4535 189.223 98.4535H184.229V96.8701H189.223C192.414 96.8701 195 99.4834 195 102.707V153.163C195 156.387 192.414 159 189.223 159H146.777C143.586 159 141 156.387 141 153.163V102.707Z" fill="#929CA9"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M145.992 103.974C145.992 102.143 147.461 100.659 149.273 100.659H151.769V102.243H149.273C148.326 102.243 147.559 103.018 147.559 103.974V151.906C147.559 152.863 148.326 153.638 149.273 153.638H186.725C187.671 153.638 188.438 152.863 188.438 151.906V103.974C188.438 103.018 187.671 102.243 186.725 102.243H184.228V100.659H186.725C188.536 100.659 190.005 102.143 190.005 103.974V151.906C190.005 153.737 188.536 155.221 186.725 155.221H149.273C147.461 155.221 145.992 153.737 145.992 151.906V103.974Z" fill="#929CA9"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M161.759 99.7201H159.262V98.1367H161.759V99.7201Z" fill="#929CA9"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M169.251 99.7201H166.754V98.1367H169.251V99.7201Z" fill="#929CA9"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M176.739 99.7201H174.242V98.1367H176.739V99.7201Z" fill="#929CA9"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M169.251 90.8851H166.754V89.3018H169.251V90.8851Z" fill="#929CA9"/>
                      <rect x="152.195" y="110.139" width="3.72345" height="3.77778" stroke="#929CA9" stroke-width="1.5"/>
                      <rect x="152.195" y="118.056" width="3.72345" height="3.77778" stroke="#929CA9" stroke-width="1.5"/>
                      <rect x="152.195" y="125.973" width="3.72345" height="3.77778" stroke="#929CA9" stroke-width="1.5"/>
                    </g>
                    <path d="M114 88.0869L124.498 93.0874" stroke="#929CA9" stroke-width="2.5"/>
                    <path d="M127.5 82.5869L123.394 93.5338" stroke="#929CA9" stroke-width="2.5"/>
                    <path d="M1 15.0875C45.5 13.5871 98.5 31.0869 123 91.0874" stroke="#929CA9" stroke-width="2.5" stroke-linejoin="bevel" stroke-dasharray="6 6"/>
                    <rect x="74" width="49" height="20" rx="4" fill="#929CA9" fill-opacity="0.2"/>
                    <rect x="81.75" y="5.75" width="3.5" height="3.5" stroke="#929CA9" stroke-width="1.5"/>
                    <line x1="89" y1="7.25" x2="113" y2="7.25" stroke="#929CA9" stroke-width="1.5"/>
                    <line x1="89" y1="12.25" x2="107" y2="12.25" stroke="#929CA9" stroke-width="1.5"/>
                    <defs>
                      <clipPath id="clip0_3327_18240">
                        <rect width="54" height="76" fill="white" transform="translate(141 83)"/>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <h5>Drag & Drop Fragen</h5>
                <p>Wählen Sie zuerst Fragen und dann ziehen sie hierher,
                  um eine Seite aufzubauen.</p>
              </drop>
            </div>
            <div v-else>
              <div style="float:right">
                <IconTooltipButtonBottom
                    icon="mdi-file-document-plus-outline"
                    tooltip="Seite hinzufügen"
                    id="default"
                    width="36px"
                    @click="addPage()"
                    color="secondary"
                />
                <IconTooltipButtonBottom
                    icon="mdi-file-document-remove-outline"
                    tooltip="Seite entfernen"
                    id="default"
                    width="36px"
                    @click="deletePage()"
                    color="gray"
                />
              </div>
              <v-tabs v-model="selectedPage" class="border-bottom mb-4" color="secondary">
                <v-tab v-for="(page, index) in pages" :key="index" @click="selectedPage = index">Seite {{index+1}}</v-tab>
              </v-tabs>
              <drop v-if="selectedPage != null" class="column" @drop="onDrop" tag="v-list" three-line>
                <template>
                  <v-list-item >
                    <v-list-item-avatar color="gray_4" size="56">
                      <span class="text-gray">
                        <span class="font-l font-weight-black" style="line-height: 2px">
                          {{pages[selectedPage].questions ?
                          pages[selectedPage].questions.length:
                          ""}}
                        </span> <br>
                        <span class="text-description">Frage<span v-if="pages[selectedPage].questions.length > 1">n
                        </span></span>
                      </span>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <div v-show = "pages[selectedPage].edit == false"  @mouseover="onMouseOver=true"
                           @mouseleave="onMouseOver=false" class="ml-2">
                        <v-list-item-title style="cursor:pointer" @click = "pages[selectedPage].edit = true">
                          <label style="cursor:pointer"> {{pages[selectedPage].title}} </label>
                          <v-icon v-if="onMouseOver" small color="gray_3" class="ml-1">mdi-pencil</v-icon>
                        </v-list-item-title>
                      </div>
                      <input style="border: 0.5px solid gray" v-show = "pages[selectedPage].edit == true" v-model = "pages[selectedPage].title"
                             v-on:blur= "pages[selectedPage].edit=false; $emit('update')"
                             @keyup.enter = "pages[selectedPage].edit=false; $emit('update')">

                      <v-row v-for="question in pages[selectedPage].questions" :key="question.id"
                             class="question-box full-width">
                        <v-col cols="11">
                            <span class="font-s font-weight-bold bg-gray px-3 py-2 text-gray d-inline-block">
                              {{pages[selectedPage].questions.indexOf(question) + 1}}
                            </span>
                          <PXSurvey :schema="getQuestionSchema(question)" :displayMode="'display'" id="px-survey-preview"/>
                        </v-col>
                        <v-col cols="1" class="d-flex align-start justify-end pa-0 pr-2 pt-1">
                          <IconTooltipButtonBottom
                              icon="mdi-delete"
                              tooltip="Frage entfernen"
                              id="default"
                              small
                              width="32px"
                              @click="removeQuestion(question)"
                          />
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </drop>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="currentStep === 1" class="ma-unset d-flex justify-space temp-bottom">
      <v-col class="pa-0"></v-col>
      <v-col v-if="selectedQuestions.length != 0" cols="10" class="text-right"><v-chip id="chip" color="primary"
                                                                                       class="mr-2">{{
          selectedQuestions.length }}</v-chip>Fragen wurden
        ausgewählt</v-col>
      <v-col class="ma-0 mb-6 pa-0 d-flex px-10 justify-end">
        <v-btn elevation="0" color="secondary" class="mt-4 justify-end" :disabled="pages[0].questions.length === 0"
               @click="questionsSelectedDone()"
        > Weiter <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="currentStep === 2" class="ma-unset">
      <AddSurveyGlobalSetting :isIWAKQuestion="false" :currentStep="currentStep" :surveyDetails="surveyDetails"
                              :selectedQuestions="selectedQuestions" ref="globalSetting" @changeStep="changeStep($event)" />
    </v-row>
    <v-row v-if="currentStep === 3" class="ma-unset">
      <AddSurveyPreview :pxQuestions="pxQuestions" :selectedQuestions="selectedQuestions"
                        :surveyDetails="surveyDetails"
                        :schema="schema"
                        ref="surveyPreview"
                        @changeStep="changeStep($event)"/>
    </v-row>
    <PXCreateQuestionModal ref="createQuestion" />
  </div>
</template>


<script>
import pxQuestionService from '@/pages/PxQuestionSurvey/PXQuestionsPage/px-question-service'
import FormDialog from '@/components/common/FormDialog.vue';
import surveyGenerator from '@/components/px-survey-generator'
import {Drag, Drop} from "vue-easy-dnd";
import AddSurveyTextDialog from '../../../components/common/AddSurveyTextDialog.vue';
import ConfirmDialog from '../../../components/common/ConfirmDialog.vue';
import IconTooltipButtonBottom from '../../../components/common/IconTooltipButtonBottom.vue';
import InfoboxTooltip from '../../../components/common/InfoboxTooltip.vue';
import PXCreateQuestionModal from '../PXQuestionsPage/PXCreateQuestionModal.vue';
import AddSurveyPreview from './AddSurveyPreview.vue';
import AddSurveyGlobalSetting from './AddSurveyGlobalSetting.vue';
import PXSurvey from '../../../components/common/PXSurvey.vue';
export default {
  components: {
    Drag,
    Drop,
    AddSurveyTextDialog,
    ConfirmDialog,
    AddSurveyPreview,
    AddSurveyGlobalSetting,
    PXSurvey,
    PXCreateQuestionModal,
    IconTooltipButtonBottom,
    InfoboxTooltip,
},
  data: () => ({
    steps: [
      {idx: 1, text: 'Fragen auswählen'},
      {idx: 2, text: 'Titel der Startseite'},
      {idx: 3, text: 'Vorschau'},
    ],
    headers: [
        { text: 'Frage', value: 'text'},
        /* { text: 'Erstellt von', value: 'createdBy'}, */
        { text: 'Antworttyp', value: 'answerType'},
        { text: '', value: 'actions'},
    ],
    currentStep: 1,
    selectedQuestions: [],
    pxQuestions: [],
    selected: [],
    singleExpand: true,
    pages: [{
      questions: [],
      title: "Seite 1",
      edit:false
    }],
    surveyDetails: {
      title: '',
      description: '',
      customTitlePage: false
    },
    schema: {},
    selectedPage: 0,
    search: '',
    onMouseOver: false,
    filteredQuestions: []
  }),
  props: {
    
  },
  computed: {
  },
  watch: {
  },
  mounted() {
      this.fetchPxQuestions();
  },
  methods: {
      getItem(item){
        return this.selected.length > 0 ? this.selected:item;
      },
      getQuestionSchema(question){
        return surveyGenerator.buildQuestionPreview(question.text, question.answerType, question.answerOptions);
      },
      updateSelectedQuestions(checkboxValue, question){
          if(this.selectedQuestions.includes(question) && !checkboxValue){
              let indexOfSelected = this.selectedQuestions.indexOf(question);
              this.selectedQuestions.splice(indexOfSelected, 1);
          }else{
              this.selectedQuestions.push(question);
          }
      },
      fetchPxQuestions(){
          pxQuestionService.getCustomQuestions().then((result) => {
              this.pxQuestions = result.data;
              this.filteredQuestions = this.pxQuestions;
          })
      },
      generateSurvey(){   
        this.$refs.formDialog
        .open(
        "Bitte geben Sie der Umfrage einen Namen:"
        )
        .then((surveyDetails) => {
            let selectedQuestions = this.pxQuestions.filter(elem => this.selectedQuestions.includes(elem.module));
            let schema = surveyGenerator.buildManualSchemaForSurvey(this.pages, surveyDetails);
            this.$router.push({
                name: 'generatedSurvey',
                params: {
                    schema: schema,
                    surveyTitle: surveyDetails.title
                }
            })
        });
      },
      backToList() {
        this.$refs.backToListDlg
            .open(
                "Zurück zur Übersichtsliste",
                "Möchten Sie zurück zur Liste gehen? Diese Umfrage wird verworfen.",
                {width: 500,}
            )
            .then(() => { this.$router.push('/surveys');})
      },
      onDrop(event) {
        if(Array.isArray(event.data)){
          this.pages[this.selectedPage].questions.push(...event.data);
          event.data.forEach(elem => {
            let indx = this.pxQuestions.indexOf(elem);
            this.pxQuestions.splice(indx, 1);
          })
        }else{
          this.pages[this.selectedPage].questions.push(event.data);
            let indx = this.pxQuestions.indexOf(event.data);
            this.pxQuestions.splice(indx, 1);
        }
        this.selected = [];
        /* let title = "Seite " +(this.pages.length+1);
        this.pages.push({
            title: title,
            questions: event.data,
            edit: false
        });
        this.selected = []; */
    },
    questionsSelectedDone() {
        this.currentStep = 2;
      },
      changeStep(changedProp) {
        this.currentStep = changedProp;
        if(this.currentStep === 3){
            this.schema = surveyGenerator.buildManualSchemaForSurvey(this.pages, this.surveyDetails);
        }
      },
      deletePage(){
        this.pxQuestions.push(...this.pages[this.selectedPage].questions);
        if(this.pages.length > 1) {
          this.pages.splice(this.selectedPage, 1);
        } else if(this.pages.length === 1) {
          this.pages = [{
            questions: [],
            title: "Seite 1",
            edit:false
          }];
        }
        this.selectedPage = 0;
      },
      addPage(){
        this.pages.push({
          questions: [],
          title: "Seite "+(this.pages.length+1),
          edit:false
        })
        this.selectedPage = this.pages.length-1;
      },
      removeQuestion(question){
        let indx = this.pages[this.selectedPage].questions.indexOf(question);
        this.pages[this.selectedPage].questions.splice(indx, 1);
        this.pxQuestions.push(question);
      },
    createQuestion() {
      this.$refs.createQuestion
          .open(
              'Neue Frage hinzufügen',
              {width: 1000}, false
          ).then(() => { this.fetchPxQuestions(); })
    },
    showInfobox() {
      this.$refs['infoBox'].open("Beim erstellen einer manuellen Umfrage können Sie nur Fragen auswählen, welche nicht dem Prozessperspektivenmodul zugehörig sind.");
    },
    hideInfobox() {
      this.$refs['infoBox'].close();
    },
    isEmpty() {
        let questions = 0;
        let pages = this.pages;
        for (const key in pages) {
          if(pages.hasOwnProperty(key)){
            questions += pages[key].questions.length;
          }
        }
        return questions == 0;
    },
    currentItems(value) {
      this.filteredQuestions = value
    }
  },
};
</script>
<style scoped lang="less">
.stepper {
  height: 40px;
}

.focus {
  font-weight: 700 !important;
  color: var(--v-primary-base);
}

.no-focus {
  color: var(--v-gray_3-base);
}

.stepper-numbering {
  display: inline-flex;
  width: 20px;
  height: 18px;
  border-radius: 4px;
  padding: 3px 8px;
  margin: 0;
  font-size: 12px;
  justify-content: center;
  margin-right: 8px;
}

.stepper-numbering__focus {
  /*background: var(--v-primary-base);*/
  font-weight: 700;
}

.stepper-numbering__focus::before {
  content:"";
  display: block;
  position: absolute;
  width: 20px;
  border-radius: 4px;
  height: 18px;
  opacity: .1;
  background: var(--v-primary-base);
}

.stepper-numbering__no-focus {
  font-weight: 700;
}

.stepper-numbering__no-focus::before {
  content:"";
  display: block;
  position: absolute;
  width: 20px;
  border-radius: 4px;
  height: 18px;
  opacity: .1;
  background: var(--v-gray_3-base);
}
.frame{
    border: 1px solid lightgray;
    margin:5px;
}
.row{
    margin:5px;
}
.filter{
    width:10%;
    float:right;
    margin-right: 10px;
}
.table-header{
    padding:0 !important
}
.bottomButton{
    width: calc(100% - 20px);
    margin:10px;
}
.scrollQuestions{
    height:250px;
    overflow-x: auto;
}
.col-3{
    padding: 2.5px
}
.col-5{
  background-color:white;
  padding: 0px;
}
.question-main {
  height: calc(100vh - 172px - 57px - 50px);
  border-radius: 10px;
  padding: 24px 24px 12px 24px;
  background: white;
  .col {
    overflow-y: auto;
    padding: 0;
  }
  .col-5 {
    padding-right: 20px;
    height: calc(100vh - 172px - 57px - 86px);
    overflow-y: auto;
  }
  .col-7 {
    height: calc(100vh - 172px - 57px - 86px);
    overflow-y: auto;
  }
}
.empty-image {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  text-align: center;
  div {
    margin-bottom: 25px;
  }
  p {
    max-width: 380px;
    margin-top: 20px;
  }
}
.h1, .h2, .h3, h1, h2, h3{
    margin: 0 !important;
}
.column{
    overflow: auto;
    //height: calc(100vh - 172px - 57px - 50px);
}
#px-survey-preview{
  padding: 0 !important;
}
:deep .sv_body{
  padding: 0 !important;
}
:deep .ql-toolbar.ql-snow+.ql-container.ql-snow{
  height:25vh
}
:deep .sv_main.sv_default_css .sv_body{
  border: none;
  .sv_main .sv_q_num {
    display: none;
  }
  .sv-vue-title-additional-div {
    margin-left: -10px;
  }
}
.question-box {
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
  margin-bottom: 10px !important;
  .col-1 {
    vertical-align: middle;
  }
}
:deep .v-data-table__wrapper table {
  margin-top: 0;
  thead > th {
    height: 40px !important;
  }
  td, th {
    padding: 0 8px !important;
  }
  th:first-child, td:first-child {
    width: 40px !important;
  }
  td:nth-child(2) {
    text-align: center !important;
  }
  tbody tr.v-data-table__expanded__content {
    -webkit-box-shadow: inset 0 4px 8px -5px rgba(0, 0, 0, 0.25);
    box-shadow: inset 0 4px 8px -5px rgba(0, 0, 0, 0.25) !important;
  }
}
:deep .v-divider--vertical {
  z-index: 99;
}
:deep .sv_custom_header {
  display: none;
}
:deep .px-pages-preview .sv_row .sv_q_matrix {
  margin-top: -50px;
}
:deep .sv_q_num {
  display: none;
}
:deep .sv_q.sv_qstn .table {
  margin-top: 0rem;
}
:deep .sv_header__text h3 {
  font-size: 2rem !important;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table {
  display: flex;
  flex-direction: column-reverse;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table tr {
  display: flex;
  flex-direction: column;
  width: 100%;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table thead td {
  display: none;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table thead tr {
}
:deep .sv_main .sv_container .sv_body .sv_p_root table th {
  width: 100%;
  height: 40px !important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: 3em;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table tbody tr {
  height: 60px;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table tbody td {
  //height: 60px;
  padding: 0 0 0 10px;
  line-height: 1.3em;
}
:deep .sv_main .sv_container .sv_body .sv_p_root table tbody td:first-child span {
  height: 60px;
  display: flex;
  align-items: center;
}
:deep .sv_qstn label.sv_q_m_label {
  position: unset !important;
  display: flex !important;
  height: 40px;
  padding: 0;
  align-items: center;
}
:deep table.sv_q_matrix td {
  min-width: 100% !important;
}
:deep table.sv_q_matrix thead tr th {
  margin-left: 1.7em;
}

:deep .v-data-table__wrapper .table.table-striped {
  td {
    min-width: 100% !important;
  }
  thead tr th {
    margin-left: 1.7em;
    height: 40px !important;
  }
}
:deep .table.table-striped {
  thead th {
    height: 40px !important;
  }
  tbody td {
    height: 40px;
  }
  tbody td:first-child {
    height: 60px;
  }
  label.sv_q_m_label {
    height: 40px;
  }
}
</style>